import { APPLICATION_ROUTES } from '@philips-emr/hpms-provider-accreditation-commons';
import { applicationModuleRegistry } from '@philips-emr/tws-foundation';

export function setupCalls(): void {
  applicationModuleRegistry.register({
    entry: 'calls',
    id: 'calls',
    name: 'pa.calls',
    route: APPLICATION_ROUTES.CALLS,
    order: 4,
  });
}
